export { useSimpleDragToClose } from './useSimpleDragToClose';
